import { Stack, Typography } from '@mui/material';

interface SimpleTextOverlayProps {
  label: string;
}
export const SimpleTextOverlay = ({ label }: SimpleTextOverlayProps) => (
  <Stack
    sx={{
      justifyContent: 'center',
      height: '100%',
    }}
  >
    <Typography align="center" variant="body2" color="textSecondary">
      {label}
    </Typography>
  </Stack>
);
